"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const chooseLocationContext_1 = require("../chooseLocationContext");
const LanguageRadioButton = ({ language, isChecked }) => {
    const { dispatch } = (0, chooseLocationContext_1.useChooseLocationContext)();
    const inputRef = React.useRef(null);
    const onEnterPress = (event) => {
        if (event.key === 'Enter' && inputRef.current) {
            inputRef.current.checked = true;
            dispatch({ type: chooseLocationContext_1.ChooseLocatioActionType.SET_SELECTED_LANGUAGE_URL, payload: language.url });
        }
    };
    return ((0, jsx_runtime_1.jsx)("label", { className: "px-md md:py-xs hover:bg-fill-primary-hovered flex cursor-pointer items-center rounded-2xl py-[14px]", tabIndex: 0, htmlFor: language.url, onKeyUp: onEnterPress, children: (0, jsx_runtime_1.jsxs)("div", { className: "form-radio", children: [(0, jsx_runtime_1.jsx)("input", { type: "radio", name: "language", value: language.url, tabIndex: -1, id: language.url, checked: isChecked, onChange: event => dispatch({
                        type: chooseLocationContext_1.ChooseLocatioActionType.SET_SELECTED_LANGUAGE_URL,
                        payload: event.target.value,
                    }), ref: inputRef }), (0, jsx_runtime_1.jsx)("span", { className: "body-md mt-[-4px]", children: language.name })] }) }));
};
exports.default = LanguageRadioButton;
